<template>
    <div class="card asset-card">
        <span
            v-if="enableToggleFavorite || currentAsset.is_favorite"
            title="Favorite Asset"
            class="favorite-asset d-flex flex-row"
            :class="{ clickable: enableToggleFavorite }"
            @click="toggleFavorite"
        >
            <icon-star
                :active="currentAsset.is_favorite"
                height="20px"
                width="20px"
            ></icon-star>
        </span>
        <div class="image-container" ref="anchor">
            <a
                v-if="bg"
                :style="'background-image: url(' + bg + ');'"
                :href="'/advertiser/assets/' + currentAsset.id"
                class="asset-image"
                title="Asset Image"
            >
            </a>
            <div class="team-logo" v-if="currentAsset.team_logo">
                <t-img :src="currentAsset.team_logo" alt="Team Logo"></t-img>
            </div>
        </div>
        <div class="card-body">
            <h5 class="card-title">
                <a :href="'/advertiser/assets/' + currentAsset.id" :title="currentAsset.name">{{ currentAsset.name }}</a>
            </h5>
            <ul class="attributes-list">
                <li>
                    {{ currentAsset.team_name }}
                    <template v-if="asset && currentAsset.venue_name"> |</template>
                    {{ currentAsset.venue_name }}
                </li>
                <li>{{ currentAsset.league_name }}</li>
                <li>{{ currentAsset.market }}</li>
                <li>
                    From
                    <span class="money">{{ currentAsset.price | money }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { getResponsiveSrc } from '@jgile/laravel-vue/resources/js/lib/helpers';

export default {
    props: {
        asset: {
            required: true,
        },
        enableToggleFavorite: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        bg: null,
        currentAsset: null,
        togglingFavorite: false
    }),
    methods: {
        getResponsiveSrc,

        async toggleFavorite() {
            if (!this.enableToggleFavorite || this.togglingFavorite) {
                return;
            }

            try {
                this.togglingFavorite = true;

                const response = await axios.post('/api/favorites/toggle', {
                    model_name: 'App\\Modules\\Assets\\Models\\Asset',
                    model_id: this.currentAsset.id
                });

                // Update the local state
                this.currentAsset.is_favorite = response.data.is_favorite;

                // Emit event to parent component
                this.$emit('favorite-toggled', this.currentAsset.id, response.data.is_favorite);

                // Emit global event to update sidebar
                Bus.$emit('favoriteToggled', this.currentAsset.id, response.data.is_favorite);

            } catch (error) {
                console.error('Failed to toggle favorite:', error);
                // You might want to show a toast or error message here
            } finally {
                this.togglingFavorite = false;
            }
        }
    },
    watch: {
        asset: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.currentAsset = newVal;

                this.$nextTick(function () {
                    let width = parseFloat(getComputedStyle(this.$refs.anchor, null).width.replace('px', ''));
                    this.bg = this.getResponsiveSrc(_.get(this.currentAsset, 'first_media.responsive_image_urls'), width, this.currentAsset.image);
                });
            },
        },
    },
};
</script>

<style scoped>
.favorite-asset.clickable {
    cursor: pointer;
}

.favorite-asset.clickable:hover {
    opacity: 0.8;
}
</style>
